module.exports = "/_next/static/images/AicpaSocBadge@2x-85c9e613dfc2024023d4708185a963e1.webp";